export enum Gender {
	Man = "MALE",
	Woman = "FEMALE",
	Other = "UNDEFINED",
}

export function stringToGender(text?: string | null): Gender {
	if (text === "MALE") {
		return Gender.Man;
	}
	if (text === "FEMALE") {
		return Gender.Woman;
	}
	return Gender.Other;
}
